module.exports = __webpack_public_path__ + "img/Aura_fire.6ee3e9a7.png";